import { render, staticRenderFns } from "./PurchaseCancel.vue?vue&type=template&id=34c23286"
import script from "./PurchaseCancel.vue?vue&type=script&lang=js"
export * from "./PurchaseCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports